import ReactWeather, {useOpenWeather} from 'react-open-weather';
import "../data/css/Weather.scss"

function Weather() {
    const {data, isLoading, errorMessage} = useOpenWeather({
        key: '1e38abda7ce5addc8986d1381f9cbd01',
        lat: '54.3520',
        lon: '18.6466',
        lang: 'pl',
        unit: 'metric', // values are (metric, standard, imperial)
    });


    return (
        <div className={"aalp1"}>
            <h2 className={"title pb-0 text-center"}>Weather</h2>
            <h5 className={"text-center pb-5 color-gray"}>Just in case you don't have a window.</h5>
            <div className={"weather"}>
            <ReactWeather
                isLoading={isLoading}
                errorMessage={errorMessage}
                data={data}
                lang="en"
                locationLabel="Gdańsk"
                unitsLabels={{temperature: 'C', windSpeed: 'Km/h'}}
                showForecast
            />
            </div>
        </div>
    );
}

export default Weather;
